import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { Logo } from './Logo';

const useStyles = makeStyles({
    footerNav: {
        "& li": {
            listStyleType: 'none'
        }
    },
    separator: {
        marginTop: 75,
        marginBottom: 75,
        borderTop: '1px solid gainsboro'
    }
})

export const Footer = () => {
    const classes = useStyles();

    return (
        <footer>
            {/* <div className={classes.separator}></div> */}
            <Grid container>
                {/* <Grid item><Logo /></Grid> */}
                <Grid item>
                    <ul className={classes.footerNav}>
                        {/* <li><Link underline='hover' component={RouterLink} to="/">Home</Link></li> */}
                    </ul>
                </Grid>
            </Grid>
        </footer>
    );
}